export const reducer = (state, action)=>{
    switch(action.type){
        case 'bold':
            return {...state, isbold: !state.isbold};
        case 'italic':
            return {...state, isItalic: !state.isItalic};
        case 'highlight':
            return {...state, isHighlight: !state.isHighlight};
        case 'strikethrough':
            return {...state, isStrikeThrough: !state.isStrikeThrough};
        case 'copy':
            return {...state, copy: action.payload};
        case 'editormode':
            return {...state, isEditorMode: !state.isEditorMode};
        case 'writeblogtext':
            return {...state, blogText: action.payload};
        case 'selection':
            return {...state, selection: action.payload};
        case 'carboncopy':
            return {...state, showCC: action.payload};
        case 'preparedVidBlob':
            return {...state, preparedVidBlob: action.payload};
        case 'thumbBlob':
            return {...state, thumbBlob: action.payload};
        case 'createShorts':
            return {...state, createShorts: action.payload};
        case 'selectedShortVidUri':
            return {...state, selectedShortVidUri: action.payload};
        case 'preparedShortsVidBlob':
            return {...state, preparedShortsVidBlob: action.payload};
        case 'shortVidThumbUri':
            return {...state, shortVidThumbUri: action.payload};
        case 'shortsVidThumbBlob':
            return {...state, shortsVidThumbBlob: action.payload};
        case 'videoSize':
            return {...state, videoSize: action.payload};
        case 'videoDuration':
            return {...state, videoDuration: action.payload};
        case 'shortsDescText':
            return {...state, shortsDescText: action.payload};
        case 'shortsDescCount':
            return {...state, shortsDescCount: action.payload};
        case 'uploadProgress':
            return {...state, uploadProgress: action.payload};
        case 'progressIndicator':
            return {...state, progressIndicator: action.payload};
        case 'videoData':
            return {...state, videoData: action.payload};
        case 'vidBuffering':
            return {...state, vidBuffering: action.payload};
        case 'showAlert':
            return {...state, showAlert: action.payload};
        case 'alertMessage':
            return {...state, alertMessage: action.payload};
        case 'message':
            return {...state, message: action.payload};
        case 'showEmojis':
            return {...state, showEmojis: action.payload};
        case 'comments':
            return {...state, comments: action.payload};
        case 'loveCount':
            return {...state, loveCount: action.payload};
        case 'likesCount':
            return {...state, likesCount: action.payload};
        case 'prayCount':
            return {...state, prayCount: action.payload};
        case 'showConfirmDialog':
            return {...state, showConfirmDialog: action.payload};
        case 'confirmDialogdesc':
            return {...state, confirmDialogdesc: action.payload};
        case 'showHistory':
            return {...state, showHistory: action.payload};
        case 'profilePic':
                return {...state, profilePic: action.payload};
        case 'showChatEmojis':
                return {...state, showChatEmojis: !state.showChatEmojis};
        case 'hideFromView':
                return {...state, hideFromView: !state.hideFromView};
        case 'imageUrl':
                return {...state, imageUrl: action.payload};
        case 'imageTitle':
                return {...state, imageTitle: action.payload};
        case 'openImageView':
                return {...state, openImageView: !state.openImageView};
        case 'textAreaHeight':
                return {...state, textAreaHeight: action.payload};
        case 'views':
                return {...state, views: action.payload};
        case 'shares':
                return {...state, shares: action.payload};
        case 'commentCounut':
                return {...state, commentCounut: action.payload};
        case 'edifiedCount':
                return {...state, edifiedCount: action.payload};
        case 'regularUserEdified':
                return {...state, regularUserEdified: action.payload};
        case 'userProfile':
                return {...state, userProfile: action.payload};
        case 'openBottomSheet':
                return {...state, openBottomSheet: !state.openBottomSheet};
        case 'bookTitle':
                return {...state, bookTitle: action.payload};
        case 'reviewerName':
                return {...state, reviewerName: action.payload};
        case 'country':
                return {...state, country: action.payload};
        case 'showDelete':
                return {...state, showDelete: action.payload};
        case 'showMenu':
                return {...state, showMenu: action.payload};
        case 'showCountryList':
                return {...state, showCountryList: action.payload};
        case 'sendingTask':
                return {...state, sendingTask: action.payload};
        case 'showReplyBox':
                return {...state, showReplyBox: action.payload};
        case 'replyText':
                return {...state, replyText: action.payload};
        case 'notificationText':
                return {...state, notificationText: action.payload};
        case 'notiificationImage':
                return {...state, notiificationImage: action.payload};
        case 'lastDocFetched':
                return {...state, lastDocFetched: action.payload};
        case 'recentNotifications':
                return {...state, recentNotifications: action.payload};
        case 'showReviewSheet':
                return {...state, showReviewSheet: action.payload};
        case 'bookReviewData':
                return {...state, bookReviewData: action.payload};
        case 'userNameToDisplay':
                return {...state, userNameToDisplay: action.payload};
        case 'userProfilePic':
                return {...state, userProfilePic: action.payload};
        case 'scrollDirection':
                return {...state, scrollDirection: action.payload};
        case 'mute':
                return {...state, mute: action.payload};
        case 'displayEdifiedList':
                return {...state, displayEdifiedList: action.payload};
        case 'userBio':
                return {...state, userBio: action.payload};
        case 'userEmail':
                return {...state, userEmail: action.payload};
        case 'userVerified':
                return {...state, userVerified: action.payload};
        case 'vcode':
                return {...state, vcode: action.payload};
        case 'showOptionalDialog':
                return {...state, showOptionalDialog: action.payload};
        case 'shareDialog':
                return {...state, shareDialog: action.payload};
        case 'showBottomSheet':
                return {...state, showBottomSheet: action.payload};
        case 'videoUrl':
                return {...state, videoUrl: action.payload};
        case 'capturedThumbnail':
                return {...state, capturedThumbnail: action.payload};
        case 'videoDescription':
                return {...state, videoDescription: action.payload};
        case 'audioUrl':
                return {...state, audioUrl: action.payload};
        default:
            throw new Error();
    };
};

export const actionConsts = {
    BOLD: 'bold',
    ITALIC: 'italic',
    HIGHLIGHT: 'highlight',
    STRIKE: 'strikethrough',
    TEXT: 'writeblogtext',
    SELECTION: 'selection',
    CARBONCOPY: 'carboncopy',
    EDITORMODE: 'editormode',
    PREPAREDVIDBLOB: 'preparedVidBlob',
    THUMBBLOB: 'thumbBlob',
    CREATESHORTS: 'createShorts',
    SELECTEDSHORTVID: 'selectedShortVidUri',
    PREPAREDSHORTVID: 'preparedShortsVidBlob',
    SHORTVIDTHUMB: 'shortVidThumbUri',
    SHORTVIDTHUMBBLOB: 'shortsVidThumbBlob',
    VIDEOSIZE: 'videoSize',
    VIDEO_DURATION: 'videoDuration',
    SHORTS_DESC: 'shortsDescText',
    SHORTS_DESC_COUNT: 'shortsDescCount',
    UPLOAD_PROGRESS: 'uploadProgress',
    PROGRESSINDICATOR: 'progressIndicator',
    VIDEODATA: 'videoData',
    VID_BUFFERING: 'vidBuffering',
    SHOWALERT: 'showAlert',
    ALERT_MESSAGE: 'alertMessage',
    MESSAGE: 'message',
    SHOWEMOJIS: 'showEmojis',
    COMMENTS: 'comments',
    LOVECOUNT: 'loveCount',
    LIKECOUNT: 'likesCount',
    PRAYCOUNT: 'prayCount',
    CONFIRMDIALOG: 'showConfirmDialog',
    CONFIRMDIALOGDESC: 'confirmDialogdesc',
    SHOWHISTORYTAB: "showHistory",
    PROFILE_PIC: "profilePic",
    SHOW_CHAT_EMOJIS: "showChatEmojis",
    HIDE_VIEW: "hideFromView",
    IMAGE_URL: "imageUrl",
    iMAGE_TITLE: "imageTitle",
    OPEN_IMAGE_VIEW: "openImageView",
    TEXT_AREA_HEIGHT: "textAreaHeight",
    VIEWS: "views",
    SHARES: "shares",
    EDIFIED_COUNT: "edifiedCount",
    COMMENT_COUNT: "commentCounut",
    REGULAR_USER_EDIFIED: "regularUserEdified",
    USER_PROFILE: "userProfile",
    COPY: "copy",
    BOOKTITLE: "bookTitle",
    OPEN_BOTTOM_SHEET: "openBottomSheet",
    REVIEWER_NAME: "reviewerName",
    COUNTRY: "country",
    SHOW_MENU: "showMenu",
    SHOW_DELETE: "showDelete",
    SHOW_COUNTRIES: "showCountryList",
    SENDING_TASK: "sendingTask",
    SHOW_REPLY_BOX: "showReplyBox",
    REPLY_TEXT: "replyText",
    NOTIFICATIONTEXT: "notificationText",
    NOTIFICATION_IMAGE: "notiificationImage",
    LAST_DOC_FETCHED: "lastDocFetched",
    NEW_NOTIFICATIONS: "recentNotifications",
    SHOW_REVIEW_SHEET: "showReviewSheet",
    BOOK_REVIEW_DATA: "bookReviewData",
    USER_NAME_DISPLAY: "userNameToDisplay",
    USER_PICTURE: "userProfilePic",
    SCROLL_DIRECTION: "scrollDirection",
    MUTE: "mute",
    DISPLAY_EDIFIED_LIST: "displayEdifiedList",
    BIO: "userBio"
};

export const actionConts2 = {
    USER_EMAIL: "userEmail",
    USER_VERIFIED: "userVerified",
    OTP: "vcode",
    OPTIONAL_DIALOG: "showOptionalDialog",
    SHARE_DIALOG: "shareDialog",
    SHOW_BOTTOMSHEET: "showBottomSheet",
    VIDEO_URL: "videoUrl",
    VIDEO_THUMBNAIL: "capturedThumbnail",
    VIDEO_DESCRIPTION: "videoDescription",
    AUDIO_URL: "audioUrl"
};